import { h } from 'preact';
import util from 'preact-util';

import GuiInfoBox from '../../components/gui/infoBox';

// The one amount header shared by every payment component in this folder. The currency comes
// from the payment (race class, contestant, payment row) and must be passed in by the caller.
// This is the ONLY place in src/components/payment/ allowed to spell out the NOK fallback:
// an ESLint override in package.json flags the literal everywhere else, so a new component
// cannot quietly show "4500 NOK" for a SEK or EUR payment again.
const DEFAULT_CURRENCY = 'NOK';

export default function PaymentAmount({ stores, title, amount, currency, styles = 'font-size: 2.5em; line-height: 1.0em;' }) {
    return (
        <GuiInfoBox
            stores={stores}
            nameMiddle={title}
            value={util.format(amount, 0)}
            postfix={currency || DEFAULT_CURRENCY}
            styles={styles}
        />
    );
}
